export default __webpack_public_path__ + "static/media/1a.ce0b5365.png";